import { useState } from 'react';
import getCheckPassword from '@services/api/password';

const usePasswordReminder = () => {
  const [isPasswordChange, setIsPasswordChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCheckPassword = () => {
    setIsLoading(true);
    getCheckPassword()
      .then((response) => {
        setIsLoading(false);  
        setIsPasswordChange(response.is_need_change);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
      });
  };
  
  return {
    isLoading,
    isPasswordChange,
    fetchCheckPassword,
  };
};

export default usePasswordReminder;
